import filter from 'lodash/filter'
import map from 'lodash/map'
import range from 'lodash/range'
import type { FunctionComponent} from 'react';
import { useMemo } from 'react'
import 'twin.macro'
import { useResponsiveStackGridOptions } from '../hooks/useResponsiveStackGridOptions'

export const NewsHubStackGrid: FunctionComponent<React.PropsWithChildren<{}>> = ({ children }) => {
  const {
    // stackGridGutterWidth,
    // stackGridGutterHeight,
    // stackGridColumnWidth,
    columnCount,
  } = useResponsiveStackGridOptions()

  // spread children to multiple columns. Round robin.
  const columns = useMemo(() => {
    const childrenAsArray = children as any[]
    return range(columnCount).map((columnIndex) => {
      const columnChildren = filter(childrenAsArray, (child, idx) => {
        return idx % columnCount === columnIndex
      })
      return columnChildren
    })
  }, [children, columnCount])

  return (
    <div tw="grid grid-cols-1 md:(grid-cols-2 gap-x-px-32) lg:(grid-cols-3 gap-x-px-64)">
      {columns.map((column, columnIndex) => {
        return (
          <div
            key={columnIndex}
            tw="flex flex-col space-y-px-48 lg:space-y-px-80"
          >
            {map(column, (child, childIndex) => {
              return <div key={childIndex}>{child}</div>
            })}
          </div>
        )
      })}
    </div>
  )
}
